import React from "react";
import Button from "reactstrap/lib/Button";
import Form from "reactstrap/lib/Form";
import Swal from "sweetalert2";
import {Toast} from "../../../../utils/sweetAlert";
import {t} from "react-switch-lang";
import {deactivateDepartment} from '../../../../services/departmentService';

const DeactivateDepartment = props => {
  const handleSubmit = async event => {
    event.preventDefault();
    await deactivateDepartment(props?.data?.id)
      .then(r => {
        Toast.fire({
          icon: "success",
          title: `${
            props?.data?.active
              ? t("message.successDeactivateDepartment")
              : t("message.successActivateDepartment")
          }`
        });
        props.setRowChanged();
        props.toggleModal();
      })
      .catch(r => {
        if (r?.response?.data?.code === 'department_deactivation_blocked_by_open_risks') {
          Swal.fire({
            text: `${t('message.departmentDeactivationBlockedByOpenRisks')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
        else if (r?.response?.data?.code === 'department_deactivation_blocked_by_open_externalizations') {
          Swal.fire({
            text: `${t('message.moduleChangeBlockedByOpenExternalizations')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
        else if (r?.response?.data?.code === 'department_deactivation_blocked_by_open_revisions') {
          Swal.fire({
            text: `${t('message.departmentDeactivationBlockedByOpenRevision')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
        Swal.fire({
          text: `${t("message.errorApi")}`,
          icon: "error",
          confirmButtonText: "OK"
        })}
      });
  };
  return (
    <Form
      onSubmit={e => handleSubmit(e)}
      noValidate
      className="d-flex justify-content-between"
    >
      <Button className="primary deleteButton">
        {props?.data?.active
          ? t("buttons.deactivateBtn")
          : t("buttons.activateBtn")}{" "}
      </Button>
    </Form>
  );
};

export default DeactivateDepartment;
